import { IUserInfoDTO } from 'src/api/dtos';
import http from 'src/api/http';
import CommonRepository from 'src/api/repositories/common/common.repository';

export default class UserInfoRepository extends CommonRepository {
  private static readonly baseRoute = '/userInfo';
  private static readonly apiURL = UserInfoRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public getUserInfo = async (): Promise<IUserInfoDTO> => {
    try {
      const { data } = await http.get(UserInfoRepository.apiURL);
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public updateUserInfo = async (payload: {
    email: string | undefined;
    cellPhone: string | undefined;
  }): Promise<IUserInfoDTO> => {
    try {
      const { data } = await http.patch<{ userInformation: IUserInfoDTO }>(UserInfoRepository.apiURL, payload);
      return data.userInformation;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
